import { render, staticRenderFns } from "./ItemAtendimento.vue?vue&type=template&id=4b28cc0b&scoped=true&"
import script from "./ItemAtendimento.vue?vue&type=script&lang=ts&"
export * from "./ItemAtendimento.vue?vue&type=script&lang=ts&"
import style0 from "./ItemAtendimento.vue?vue&type=style&index=0&id=4b28cc0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b28cc0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
